<template>
    <b-nav class="list bg-white">
        <b-nav-item
            v-for="item in availableItems"
            :key="item.path"
            class="list-item"
            @click.stop="openPage(item.path)"
        >
            <span class="text">{{ item.title }}</span>
        </b-nav-item>
    </b-nav>
</template>

<script>
import access from '@/mixins/access';
import settingsList from '@/mixins/settingsList';

export default {
    name: 'SettingsMenu',
    mixins: [access, settingsList],
    computed: {
        availableItems() {
            return this.items.filter(item => this.checkMultipleAccess(item.access));
        },
    },

    methods: {
        openPage(path) {
            if (path !== this.$route.path) {
                this.$router.push(path);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.list {
    list-style: none;
    flex-direction: column;
}

.list-item {
    padding: 0.57em 0 0.57em 3em;
}

.nav-link {
    padding: 0;
    line-height: 1.23em;
}

.text {
    color: #737373;
}
</style>